import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Sun, Moon, Menu, X, ArrowRight } from "lucide-react";
import { useTheme } from "../lib/ThemeContext";
import { Logo } from "../components/Logo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solutions", label: "Solutions" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Our Work" },
  { to: "/clients", label: "Clients" },
  { to: "/infrastructure", label: "Infrastructure" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const { theme, toggle } = useTheme();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b"
      style={{ background: "var(--nav-bg)", backdropFilter: "blur(16px)", borderColor: "var(--line)" }}
    >
      <div className="msg-container flex items-center justify-between h-[76px]">
        <Link to="/" data-testid="nav-home-logo" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={toggle}
            data-testid="theme-toggle-btn"
            aria-label="Toggle theme"
            className="w-10 h-10 flex items-center justify-center border transition-colors hover:border-[var(--brand-cyan)]"
            style={{ borderColor: "var(--line)", color: "var(--text-1)" }}
          >
            {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <Link to="/quote" data-testid="nav-quote-btn" className="btn-brand hidden md:inline-flex !py-3 !px-5">
            Request a Quote <ArrowRight size={14} />
          </Link>
          <button
            className="xl:hidden w-10 h-10 flex items-center justify-center border"
            style={{ borderColor: "var(--line)", color: "var(--text-1)" }}
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="xl:hidden border-t px-6 py-6 flex flex-col gap-4"
          style={{ background: "var(--bg)", borderColor: "var(--line)" }}
          data-testid="mobile-menu"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`nav-link ${location.pathname === l.to ? "active" : ""}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/quote" onClick={() => setOpen(false)} className="btn-brand mt-2 justify-center" data-testid="mobile-nav-quote">
            Request a Quote <ArrowRight size={14} />
          </Link>
        </nav>
      )}
    </header>
  );
};
